import { render } from "./DegreeBar.vue?vue&type=template&id=b20432ce&scoped=true"
import script from "./DegreeBar.vue?vue&type=script&lang=ts"
export * from "./DegreeBar.vue?vue&type=script&lang=ts"

import "./DegreeBar.vue?vue&type=style&index=0&id=b20432ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b20432ce"

export default script